/* GWP — Gift With Purchase popup
 * Theme-agnostic: hooks fetch + XHR to /cart/add, shows a one-time gift chooser
 * on the FIRST add-to-cart of the session. Adds exactly one chosen gift variant.
 * Pricing (0.00) is handled by an automatic "Buy X Get Y" discount, not here.
 *
 * Config + i18n strings are injected by snippets/gwp-gift-popup.liquid as
 * window.GWP_CONFIG. All user-facing text comes from theme locale files.
 */
(function () {
  'use strict';

  var CFG = window.GWP_CONFIG || {};
  var GIFTS = Array.isArray(CFG.gifts) ? CFG.gifts : [];
  var T = CFG.t || {};
  var SS_DECLINED = 'gwp_declined_v1';  // user clicked "No thanks" -> never offer again this session

  // The ONLY permanent suppressor is an explicit decline. Otherwise the offer
  // re-appears whenever a product is added and no gift is currently in the cart
  // (so a customer who removes the gift can pick a different one).
  function declined() { try { return sessionStorage.getItem(SS_DECLINED) === '1'; } catch (e) { return false; } }
  function mark(k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }

  var GIFT_IDS = GIFTS.map(function (g) { return String(g.id); });

  // ----- detect add-to-cart (theme-agnostic) -------------------------------
  function isAddUrl(url) { return typeof url === 'string' && url.indexOf('/cart/add') !== -1; }

  // Skip if the thing being added is itself a gift variant.
  function bodyIsGift(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') {
        return GIFT_IDS.some(function (id) { return body.indexOf(id) !== -1; });
      }
      if (body instanceof FormData) {
        var v = body.get('id');
        return v != null && GIFT_IDS.indexOf(String(v)) !== -1;
      }
      if (body.items) {
        return body.items.some(function (it) { return GIFT_IDS.indexOf(String(it.id)) !== -1; });
      }
      if (body.id != null) return GIFT_IDS.indexOf(String(body.id)) !== -1;
    } catch (e) {}
    return false;
  }

  function maybeTrigger(body) {
    if (!GIFTS.length || declined()) return;   // declined -> never offer again
    if (bodyIsGift(body)) return;              // the gift itself is being added
    // Let the original add finish & the cart settle, then offer only if the
    // customer doesn't already have a gift in the cart.
    setTimeout(function () {
      if (declined() || overlay) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (!cartHasGift(cart) && !overlay) openPopup(); })
        .catch(function () { if (!overlay) openPopup(); });
    }, 600);
  }

  // Is one of our gifts already in the cart? Matched by the hidden _gift property
  // we attach, with a gift-variant-id fallback.
  function cartHasGift(cart) {
    try {
      return (cart.items || []).some(function (it) {
        var p = it.properties || {};
        return p._gift === 'true' || p._gift === true || GIFT_IDS.indexOf(String(it.id)) !== -1;
      });
    } catch (e) { return false; }
  }

  // fetch hook
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (isAddUrl(url)) maybeTrigger(init && init.body);
      } catch (e) {}
      return _fetch.apply(this, arguments);
    };
  }
  // XHR hook
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__gwpAdd = isAddUrl(url); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) { if (this.__gwpAdd) maybeTrigger(body); return _send.apply(this, arguments); };

  // ----- UI ----------------------------------------------------------------
  var overlay, selectedId = null;

  function fmtMoney(cents) {
    try {
      var loc = (document.documentElement.lang || 'en');
      var cur = CFG.currency || 'EUR';
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) { return ''; }
  }

  function buildCard(g) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'gwp-card';
    card.setAttribute('data-id', g.id);
    card.setAttribute('aria-pressed', 'false');
    var img = g.image
      ? '<img class="gwp-card__img" src="' + g.image + '" alt="" loading="lazy" width="120" height="120">'
      : '<div class="gwp-card__img gwp-card__img--ph"></div>';
    var was = g.price ? '<span class="gwp-card__was">' + fmtMoney(g.price) + '</span>' : '';
    card.innerHTML =
      img +
      '<span class="gwp-card__body">' +
        '<span class="gwp-card__title">' + g.title + '</span>' +
        '<span class="gwp-card__price">' + was +
          '<span class="gwp-card__free">' + (T.free || 'FREE') + '</span>' +
        '</span>' +
      '</span>' +
      '<span class="gwp-card__check" aria-hidden="true"></span>';
    card.addEventListener('click', function () { select(g.id, card); });
    return card;
  }

  function select(id, card) {
    selectedId = String(id);
    overlay.querySelectorAll('.gwp-card').forEach(function (c) {
      var on = c.getAttribute('data-id') === selectedId;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var cta = overlay.querySelector('.gwp-cta');
    cta.disabled = false;
    cta.textContent = T.add || 'Add my gift';
  }

  function openPopup() {
    if (overlay) { overlay.classList.add('is-open'); return; }
    overlay = document.createElement('div');
    overlay.className = 'gwp-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', T.title || 'Choose your gift');

    var modal = document.createElement('div');
    modal.className = 'gwp-modal';
    modal.innerHTML =
      '<button type="button" class="gwp-close" aria-label="' + (T.close || 'Close') + '">&times;</button>' +
      '<div class="gwp-head">' +
        '<span class="gwp-badge">' + (T.badge || 'Gift') + '</span>' +
        '<h2 class="gwp-title">' + (T.title || 'Choose your gift') + '</h2>' +
        '<p class="gwp-sub">' + (T.subtitle || 'Pick one free product — our treat.') + '</p>' +
      '</div>' +
      '<div class="gwp-grid"></div>' +
      '<button type="button" class="gwp-cta" disabled>' + (T.pick_first || 'Select a gift above') + '</button>' +
      '<button type="button" class="gwp-skip">' + (T.skip || 'No thanks') + '</button>';

    var grid = modal.querySelector('.gwp-grid');
    GIFTS.forEach(function (g) { grid.appendChild(buildCard(g)); });

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    modal.querySelector('.gwp-close').addEventListener('click', closePopup);          // × = close for now, offer again on next add
    modal.querySelector('.gwp-skip').addEventListener('click', function () { mark(SS_DECLINED); closePopup(); }); // "No thanks" = stop offering
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    modal.querySelector('.gwp-cta').addEventListener('click', addGift);
    document.addEventListener('keydown', escClose);

    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      document.documentElement.classList.add('gwp-noscroll');
    });
  }

  function escClose(e) { if (e.key === 'Escape') closePopup(); }

  function closePopup() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('gwp-noscroll');
    document.removeEventListener('keydown', escClose);
    setTimeout(function () { if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay); overlay = null; }, 250);
  }

  // Sections this theme's <mini-cart> re-renders (from its getSectionsToRender()).
  var CART_SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  function addGift() {
    if (!selectedId) return;
    var cta = overlay.querySelector('.gwp-cta');
    cta.disabled = true;
    cta.classList.add('is-loading');
    cta.textContent = T.adding || 'Adding…';

    // Single-item form + sections so the response carries pre-rendered cart HTML
    // in the exact shape the theme's renderContents(parsedState) expects.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(selectedId, 10),
        quantity: 1,
        properties: { _gift: 'true' },
        sections: CART_SECTIONS.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (state) {
        renderCart(state);   // gift now in cart -> next add won't re-offer (cart-state check)
        closePopup();
      })
      .catch(function () {
        cta.classList.remove('is-loading');
        cta.disabled = false;
        cta.textContent = T.retry || 'Try again';
      });
  }

  // Hand the add.js response to the theme's own cart renderer (it updates the
  // drawer + count bubbles and opens the drawer). Reload only if no renderer.
  function renderCart(state) {
    var host = document.querySelector('mini-cart') ||
               document.querySelector('cart-drawer') ||
               document.querySelector('cart-notification');
    try {
      if (host && typeof host.renderContents === 'function' && state && state.sections) {
        host.renderContents(state);
        return;
      }
    } catch (e) {}
    window.location.reload();
  }
})();
